export const LINE_COLORS = [
  { name: 'Bakerloo',      hex: '#b36305' },
  { name: 'Central',       hex: '#e32017' },
  { name: 'Circle',        hex: '#e6a800' },
  { name: 'District',      hex: '#00782a' },
  { name: 'Hammersmith',   hex: '#d8849a' },
  { name: 'Jubilee',       hex: '#6f7375' },
  { name: 'Metropolitan',  hex: '#9b0056' },
  { name: 'Northern',      hex: '#3a3a3a' },
  { name: 'Piccadilly',    hex: '#003688' },
  { name: 'Victoria',      hex: '#0098d4' },
  { name: 'Waterloo',      hex: '#76c0ad' },
  { name: 'Elizabeth',     hex: '#6950a1' },
];

export function daysUntil(dueDateStr) {
  const now = new Date(); now.setHours(0, 0, 0, 0);
  const due = new Date(dueDateStr + 'T00:00:00'); due.setHours(0, 0, 0, 0);
  return Math.round((due - now) / 86400000);
}

export function daysLabel(d, allDone) {
  if (allDone) return 'Done!';
  if (d < 0) return `${Math.abs(d)}d overdue`;
  if (d === 0) return 'Due today!';
  if (d === 1) return '1 day left';
  return `${d} days left`;
}

export function daysColorClass(d, allDone) {
  if (allDone) return 'badge-done';
  if (d < 0 || d <= 2) return 'badge-urgent';
  if (d <= 5) return 'badge-warn';
  return 'badge-ok';
}

export function formatDueDate(dueDateStr) {
  return new Date(dueDateStr + 'T00:00:00').toLocaleDateString('en-GB', {
    weekday: 'short', day: 'numeric', month: 'short'
  });
}

export function stepsFromAssignment(assignment) {
  if (!assignment.steps) return [];
  return [...assignment.steps].sort((a, b) => a.position - b.position);
}

export function randomColor() {
  return LINE_COLORS[Math.floor(Math.random() * LINE_COLORS.length)].hex;
}

// ── SUBJECT → LINE COLOR MAPPING ────────────────────────────
export const SUBJECT_COLORS = {
  'Math':          '#003688', // Piccadilly — blue
  'Literacy':      '#e32017', // Central — red
  'Science':       '#00782a', // District — green
  'Social Studies':'#b36305', // Bakerloo — warm amber/gold
  'French':        '#b36305', // Bakerloo — brown
  'P.E.':          '#76c0ad', // Waterloo — teal
  'Elective':      '#6950a1', // Elizabeth — violet
};

export function colorForSubject(subject) {
  return SUBJECT_COLORS[subject] || null;
}
